import Axios from 'axios';

import {
	ALL_REPORTS_LOADING_TRUE,
	ALL_REPORTS_LOADING_FALSE,
	ALL_REPORTS_GET,
	ALL_REPORTS_GET_ERROR,
	REPORT_CREATE,
	REPORT_CREATE_ERROR,
	REPORT_INFO_GET,
	REPORT_INFO_GET_ERROR,
	ORG_REPORTS_GET,
	ORG_REPORTS_GET_ERROR,
	REPORT_UPDATE_LOADING_TRUE,
	REPORT_UPDATE_LOADING_FALSE,
	REPORT_UPDATE,
	REPORT_UPDATE_ERROR,
	REPORT_REMOVE,
	REPORT_REMOVE_ERROR,
	REPORT_DOWNLOAD_LOADING_TRUE,
	REPORT_DOWNLOAD_LOADING_FALSE,
	REPORT_DOWNLOAD,
	REPORT_DOWNLOAD_ERROR,
	REPORT_DOWNLOAD_SUCCESS,
	REPORT_LOGS_LOADING_TRUE,
	REPORT_LOGS_LOADING_FALSE,
	ALL_REPORT_LOGS_GET,
	ALL_REPORT_LOGS_GET_ERROR
} from './types';

// Actions
import { getAreaType } from './overviewActions'

// Utils
import downloadViaIframe from '../utils/downloadViaIframe';

const create_report_query_params = (filters) => {
	let query_params = '';

	Object.keys(filters).forEach((f) => {
		query_params = query_params + `${f}="${filters[f]}"&`;
	})

	return query_params;
}

const create_query_params = (filters) => {
	let query_params = '';

	Object.keys(filters).forEach((f) => {
		query_params = query_params + (filters[f] !== '' ? `${f}=${filters[f]}&` : '');
	})

	return query_params;
}

const createNewOrgFilters = (orgFilters = {}) => {
	return {
		server: process.env.REACT_APP_RUNTIME === 'Test' || process.env.REACT_APP_RUNTIME === 'Development' ? 'Test' : 'Production',
		organizacion: orgFilters.organization,
		workspace: orgFilters.workspace,
		modulo: orgFilters.module,
		ciclo: orgFilters.cycle
	}
}

const createNewAreaFilters = (areaLabels = {}) => {
	let areaFiltersKeys = ['region', 'territorio', 'bodega', 'grupo'];

	let newAreaFilters = {};
	Object.keys(areaLabels).map((key, idx) => {
		if (areaLabels[key] !== '') {
			newAreaFilters[areaFiltersKeys[idx]] = areaLabels[key]
		}
	})

	return newAreaFilters;
}

export const get_all_reports = (filters) => dispatch => {
	// console.log(filters)
	dispatch({ type: ALL_REPORTS_LOADING_TRUE });

	let url = process.env.REACT_APP_SERVER_URL + '/api/reports?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: ALL_REPORTS_GET,
			payload: res.data
		});
		dispatch({ type: ALL_REPORTS_LOADING_FALSE });
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: ALL_REPORTS_GET_ERROR,
			payload: { type: 'all_reports', msg: Object.values(err.response.data)[0] }
		});
		dispatch({ type: ALL_REPORTS_LOADING_FALSE });
	})
}

export const create_report = (reportInfo = {}, skip = 0, limit = 0, closeModal) => dispatch => {
	dispatch({ type: REPORT_UPDATE_LOADING_TRUE });
	let url = process.env.REACT_APP_SERVER_URL + '/api/reports/create';

	const reportBody = { ...reportInfo, scope: 0, source: 0	};

	Axios.post(url, reportBody)
	.then(() => {
		dispatch({ type: REPORT_UPDATE_LOADING_FALSE });

		dispatch({
			type: REPORT_CREATE,
			payload: true
		});

		setTimeout(() => {
			dispatch(get_all_reports({ organization: reportInfo.organization, skip: skip, limit: limit }));
			closeModal();
		}, 2400);

		setTimeout(() => {
			dispatch({
				type: REPORT_CREATE,
				payload: false
			})
		}, 2500);
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: REPORT_CREATE_ERROR,
			payload: { type: 'create_report', msg: Object.values(err.response.data)[0] }
		});
		dispatch({ type: REPORT_UPDATE_LOADING_FALSE });
	})
}

export const get_report_info = (reportId) => dispatch => {
	dispatch({ type: ALL_REPORTS_LOADING_TRUE });

	let url = process.env.REACT_APP_SERVER_URL + `/api/reports/${reportId}/info`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: REPORT_INFO_GET,
			payload: res.data
		});
		dispatch({ type: ALL_REPORTS_LOADING_FALSE });
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: REPORT_INFO_GET_ERROR,
			payload: { type: 'report_info', msg: Object.values(err.response.data)[0] }
		});
		dispatch({ type: ALL_REPORTS_LOADING_FALSE });
	})
}

export const get_org_reports = (filters) => dispatch => {
	let url = process.env.REACT_APP_SERVER_URL + '/api/reports/data?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: ORG_REPORTS_GET,
			payload: res.data
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: ORG_REPORTS_GET_ERROR,
			payload: { type: 'organization_reports', msg: Object.values(err.response.data)[0] }
		});
	})
}

export const update_report = (reportInfo = {}, skip = 0, limit = 0, closeModal) => dispatch => {
	dispatch({ type: REPORT_UPDATE_LOADING_TRUE });
	let url = process.env.REACT_APP_SERVER_URL + `/api/reports/${reportInfo._id.$oid}/update`;

	Axios.put(url, reportInfo)
	.then(() => {
		dispatch({ type: REPORT_UPDATE_LOADING_FALSE });

		dispatch({
			type: REPORT_UPDATE,
			payload: true
		});

		setTimeout(() => {
			dispatch(get_all_reports({ organization: reportInfo.organization.$oid, skip: skip, limit: limit }));
			closeModal();
		}, 2400);

		setTimeout(() => {
			dispatch({
				type: REPORT_UPDATE,
				payload: false
			})
		}, 2500);
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: REPORT_UPDATE_ERROR,
			payload: { type: 'update_report', msg: Object.values(err.response.data)[0] }
		});
		dispatch({ type: REPORT_UPDATE_LOADING_FALSE });
	})
}

export const remove_report = (reportInfo = {}, skip = 0, limit = 0, setShowDialog) => dispatch => {
	dispatch({ type: REPORT_UPDATE_LOADING_TRUE });
	let url = process.env.REACT_APP_SERVER_URL + `/api/reports/${reportInfo._id.$oid}/remove`;

	Axios.delete(url)
	.then(() => {
		dispatch({ type: REPORT_UPDATE_LOADING_FALSE });

		dispatch({
			type: REPORT_REMOVE,
			payload: true
		});

		setShowDialog(false);
		dispatch(get_all_reports({ organization: reportInfo.organization.$oid, skip: skip, limit: limit }));

		setTimeout(() => {
			dispatch({
				type: REPORT_REMOVE,
				payload: false
			})
		}, 2500);
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: REPORT_REMOVE_ERROR,
			payload: { type: 'remove_report', msg: Object.values(err.response.data)[0] }
		});
		dispatch({ type: REPORT_UPDATE_LOADING_FALSE });
	})
}

export const download_report = (reportConfig = {}, reportFilters = {}, customFilename = null) => dispatch => {
	dispatch({
		type: REPORT_DOWNLOAD_LOADING_TRUE,
		payload: reportConfig._id.$oid
	});

	if (reportConfig.create_tab) {
		// Reports from GCP Cloud Functions
		const newOrgFilters = createNewOrgFilters(reportFilters.orgFilters);
		const newAreaFilters = createNewAreaFilters(reportFilters.areaLabels);
		const token = Axios.defaults.headers.common['Authorization'].split(' ');

		let url = `${reportConfig.action}?`;
		let query = create_report_query_params({
			...newOrgFilters,
			...newAreaFilters,
			report: reportConfig._id.$oid,
			token: token[1],
			staff: reportFilters.showStaffData
		});
		url += query;

		downloadViaIframe(url);

		dispatch({
			type: REPORT_DOWNLOAD_LOADING_FALSE,
			payload: reportConfig._id.$oid
		});
	}
	else {
		// Reports from Reports Service
		let { area_type, area } = getAreaType(reportFilters.areaFilters);

		const params = {
			...reportFilters.orgFilters,
			...reportFilters.areaFilters,
			area_type: area_type,
			report: reportConfig._id.$oid,
			staff: reportFilters.showStaffData
		};

		// Reports enriched with extra body fields from app_config (see Overview.js)
		// must be sent via POST with the body in the request payload, since browsers
		// strip the body from GET requests. Standard reports keep the original GET behavior.
		const hasExtraBody = !!reportConfig.body;

		let url = reportConfig.action;
		if (!hasExtraBody) {
			url += '?' + create_query_params(params);
		}

		// Strip empty-string params to match the original create_query_params behavior,
		// which omits them from the URL — keeps the POST body consistent with the GET version.
		const filteredParams = Object.fromEntries(
			Object.entries(params).filter(([, v]) => v !== '')
		);

		let filename = customFilename || `${reportConfig.name.toLowerCase()}-${new Date().getDate()}-${new Date().getMonth() + 1}-${new Date().getFullYear()}.csv`;

		Axios.request({
			url: url,
			method: hasExtraBody ? 'POST' : 'GET',
			responseType: 'blob',
			...(hasExtraBody && { data: { ...filteredParams, ...reportConfig.body } })
		}).then(({ data }) => {
			dispatch({
				type: REPORT_DOWNLOAD_LOADING_FALSE,
				payload: reportConfig._id.$oid
			});

			const downloadURL = window.URL.createObjectURL(new Blob([ data ]));
			const link = document.createElement('a');
			link.href = downloadURL;
			link.setAttribute('download', `${filename}`);
			document.body.appendChild(link);
			link.click();
			link.remove();

			dispatch({
				type: REPORT_DOWNLOAD_SUCCESS,
				payload: { success: true, report_id: reportConfig._id.$oid }
			});
			setTimeout(() => {
				dispatch({
					type: REPORT_DOWNLOAD_SUCCESS,
					payload: { success: false, report_id: '' }
				});
			}, 3000);
		}).catch((err) => {
			console.log(err);
			dispatch({
				type: REPORT_DOWNLOAD_ERROR,
				payload: { type: 'download_report', msg: Object.values(err.response.data)[0] }
			});

			setTimeout(() => {
				dispatch({ type: REPORT_DOWNLOAD });
			}, 3000);

			dispatch({
				type: REPORT_DOWNLOAD_LOADING_FALSE,
				payload: reportConfig._id.$oid
			});
		})
	}
}

// Set download report error manually (for validation errors)
export const set_download_report_error = (reportId, errorMsg) => dispatch => {
	dispatch({
		type: REPORT_DOWNLOAD_LOADING_FALSE,
		payload: reportId
	});

	dispatch({
		type: REPORT_DOWNLOAD_ERROR,
		payload: { type: 'download_report', msg: errorMsg }
	});

	setTimeout(() => {
		dispatch({ type: REPORT_DOWNLOAD });
	}, 3000);
}

export const get_all_report_logs = (filters) => dispatch => {
	dispatch({ type: REPORT_LOGS_LOADING_TRUE });

	let url = process.env.REACT_APP_SERVER_URL + '/api/reports/logs?';
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: ALL_REPORT_LOGS_GET,
			payload: res.data
		});
		dispatch({ type: REPORT_LOGS_LOADING_FALSE });
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: ALL_REPORT_LOGS_GET_ERROR,
			payload: { type: 'all_report_logs', msg: Object.values(err.response.data)[0] }
		});
		dispatch({ type: REPORT_LOGS_LOADING_FALSE });
	})
}
